import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ObjectUtils from '../../../modules/ObjectUtils';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';

class DetailedCitation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatAmountsDue(amountsDue) {
    const formattedAmounts = [];
    Object.keys(amountsDue).forEach(key => {
      formattedAmounts.push({
        'Due Date': moment(key).utc().format(),
        'Payment Amount': `${amountsDue[key].amount} ${amountsDue[key].currencyCode}`,
      });
    });

    return formattedAmounts;
  }

  formatTransactions(txns) {
    return ObjectUtils.formatStringAsJSONArray(txns).map(txn => ({
      'Transaction ID': txn.payItTransactionId,
      'Line Item ID': txn.lineItemId,
      'Payment Date': moment(txn.paymentDate).utc().format(),
      'Payment Amount': `${txn.amount.amount} ${txn.amount.currencyCode}`,
      'Payment Method': txn.paymentMethodType,
      'Payment Type': txn.paymentType,
      'Payment Source': txn.paymentSource || 'WEB/MOBILE',
    }));
  }

  formatLinks(links) {
    return ObjectUtils.formatStringAsJSONArray(links).map(link => ({
      'Customer ID': link.customerId,
    }));
  }

  formatClientData(clientData = {}) {
    const formattedClientData = [];
    Object.keys(clientData).forEach(key => {
      formattedClientData.push({
        Name: key,
        Value: clientData[key],
      });
    });

    return formattedClientData;
  }

  render() {
    const { citation, } = this.props;
    const amountsDue = this.formatAmountsDue(citation.citationLookup.amountsDue);
    const amountsDueModel = Grid.toModelFromList(amountsDue);

    const payments = this.formatTransactions(citation.paymentHistory);
    const paymentsModel = Grid.toModelFromList(payments);

    const links = this.formatLinks(citation.links);
    const linksModel = Grid.toModelFromList(links);

    const clientData = this.formatClientData(citation.citationLookup.clientData);
    const clientDataModel = Grid.toModelFromList(clientData);

    const items = VerticalLabelList.toList({
      'Last Updated At': moment(citation.citationLookup.updatedAt.$date).utc().format(),
      'Citation Id': citation.citationLookup.citationId,
      Description: citation.citationLookup.violationDescription,
      'Original Amount': citation.citationLookup.originalAmount ? citation.citationLookup.originalAmount.amount : '',
      'Minimum Payment Amount': citation.citationLookup.minimumPaymentAmount ? citation.citationLookup.minimumPaymentAmount.amount : '',
      Status: citation.citationLookup.status,
      'Status Description': citation.citationLookup.statusDescription,
      'Long Case Number': citation.citationLookup.longCaseNumber,
      'Short Case Number': citation.citationLookup.shortCaseNumber,
      'Citation Number': citation.citationLookup.citationNumber,
      Payable: citation.citationLookup.payable,
      'Partial Payable': citation.citationLookup.partialPayable,
      'Parking Ticket': citation.citationLookup.parkingTicket,
      'Potential License Suspension': citation.citationLookup.potentialLicenseSuspension,
      'Mandatory Court Appearance': citation.citationLookup.mandatoryCourtAppearance,
      'Warrant Case': citation.citationLookup.warrantCase,
    });

    const personItems = VerticalLabelList.toList({
      'First Name': citation.citationLookup.firstName,
      'Last Name': citation.citationLookup.lastName,
      'Date of Birth': citation.citationLookup.dateOfBirth,
      'Vehicle License Number': citation.citationLookup.vehicleLicenseNumber,
      'Vehicle License State': citation.citationLookup.vehicleLicenseState,
      'Drivers License Number': citation.citationLookup.driversLicenseNumber,
    });

    return (
      <div>
        <div>
          <FieldSet title="Citation Summary" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Person Summary" style={{ maxHeight: '300px', }}>
            <VerticalLabelList items={personItems} />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Amounts Due" style={{ maxHeight: '300px', }}>
            <Grid
              headers={amountsDueModel.headers}
              rows={amountsDueModel.format(amountsDue)}
            />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Payment History" style={{ maxHeight: '300px', }}>
            <Grid
              headers={paymentsModel.headers}
              rows={paymentsModel.format(payments)}
            />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Linked Customers" style={{ maxHeight: '300px', }}>
            <Grid
              headers={linksModel.headers}
              rows={linksModel.format(links)}
            />
          </FieldSet>
        </div>
        <div>
          <FieldSet title="Client Data" style={{ maxHeight: '300px', }}>
            <Grid
              headers={clientDataModel.headers}
              rows={clientDataModel.format(clientData)}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

DetailedCitation.defaultProps = {};

DetailedCitation.propTypes = {
  citation: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedCitation;
